"use client"

import { addNewSubscriber } from "@/services/api/external/listmonk";
import { useTranslations } from "next-intl";
import { useState, type ChangeEvent, type FormEvent } from "react";
import { useToast } from "./ui/use-toast";

export default function NewsLetterForm() {
  const t = useTranslations("BaseTemplate");
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: '',
    name: 'Anonymous',
    status: "enabled",
    lists: [
      3
    ]
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    addNewSubscriber(formData).then((res) => {
      if (res.created_at) {
        toast({
          title: "Subscribed",
          description: "You have successfully subscribed to our newsletter",
          variant: "default",
        });
      }
      setIsLoading(false);
    }).catch((err) => {
      if (err.response.data.includes("409")) {
        toast({
          title: "Already subscribed",
          description: "You are already subscribed to our newsletter",
          variant: "default",
        });
      } else {
        toast({
          title: "Something went wrong",
          description: "Please try again later",
          variant: "destructive",
        });
      }
      setIsLoading(false);
    })
  };

  return <form
    onSubmit={handleSubmit}
    className=" mt-[38px] flex flex-row items-center w-full space-x-[12px] xl:space-x-[16px] "
  >
    <input
      type="email"
      className=" bg-white w-full flex-1 rounded-[8px] lg:rounded-[10px] h-[32px] xl:h-[40px] 
     px-[19px] outline-none text-black placeholder:text-black/80"
      placeholder={t("enter_your_email_address")}
      value={formData.email}
      name="email"
      onChange={handleChange}
      required
    />
    <button
      disabled={isLoading}
      className=" bg-white md:rounded-[10px] rounded-[8px] text-black px-[18px] 
      h-[32px] lg:h-[40px] font-bold text-[12px] lg:px-[24px] relative"
    >
      {isLoading ? (
        <>
          <span className="opacity-0">{t("subscribe")}</span>
          <span className="absolute inset-0 flex items-center justify-center">
            <svg className="animate-spin h-4 w-4 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </span>
        </>
      ) : (
        t("subscribe")
      )}
    </button>
  </form>
}